import { Link } from 'react-router-dom';
import { ArrowRightIcon } from './icons';

/** Heading row for a home/page section: eyebrow, title, intro and a "see all" link. */
export default function SectionHeader({ id, eyebrow, title, intro, link, className = '' }) {
  return (
    <div className={`flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${className}`}>
      <div className="max-w-2xl">
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <h2 id={id} className="font-display text-[1.75rem] leading-tight text-ink sm:text-4xl">
          {title}
        </h2>
        {intro && <p className="mt-3 max-w-xl text-pretty text-muted">{intro}</p>}
      </div>
      {link && (
        <Link
          to={link.href}
          className="group inline-flex shrink-0 items-center gap-2 self-start text-sm font-semibold text-ink underline-offset-4 hover:underline sm:self-auto"
        >
          {link.label}
          <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      )}
    </div>
  );
}
